import { styled } from "@linaria/react";

export interface EllipsisProps {
  isPulse?: boolean;
  /**
   * The speed of the pulse animation in seconds.
   * @default 1.4
   */
  speed?: number;
}

const StyledEllipsis = styled.span<{ $isPulse: boolean; $speed: number }>`
  margin-left: 0.5px;

  & > span {
    display: inline-block;
    animation: ellipsisPulse ${({ $speed }) => $speed}s infinite ease-in-out both;
    animation-play-state: ${({ $isPulse }) => ($isPulse ? "running" : "paused")};
  }

  & > span:nth-child(1) {
    animation-delay: 0s;
  }

  & > span:nth-child(2) {
    animation-delay: 0.2s;
  }

  & > span:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes ellipsisPulse {
    0%,
    80%,
    100% {
      opacity: 0.5;
    }
    40% {
      opacity: 1;
    }
  }
`;

const Ellipsis = ({ isPulse = false, speed = 1 }: EllipsisProps) => {
  return (
    <StyledEllipsis $isPulse={isPulse} $speed={speed}>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </StyledEllipsis>
  );
};

export default Ellipsis;
